import { format } from 'date-fns';
import { getDateLocale } from '../../../lib/dateLocale';

export function formatPaymentDate(iso: string): string {
    return format(new Date(iso), 'd MMM yyyy', { locale: getDateLocale() });
}
